'use client'

import {
  GetProductsByIdsQuery,
  GetProductsByIdsQueryVariables,
} from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import React from 'react'
import { GET_PRODUCTS_BY_IDS } from '@dustin-web/microsite-data/src/graphql/product/get-products-by-ids.graphql'
import { ListItemRenderer } from '../product-list/product-list'
import { ListType } from '../product-list'
import { useGraphql } from '@dustin-web/microsite-data/src/hooks'
import { DigitalDataOrigin } from '../utils/digital-data-types'
import ConditionalWrapper from '@dustin-web/microsite-components/src/utils/conditional-wrapper'
import { isNotNullOrUndefined } from '@dustin-web/microsite-config/src/utils'
import { useResponsive } from '@dustin-web/microsite-components/src/hooks'

type Props = {
  productErpIdentifiers: string[]
  listType: ListType
  gallerySizeClasses?: string
  digitalDataOrigin: DigitalDataOrigin
  oneProductOnly?: boolean
}

export const ProductListByIds = ({
  productErpIdentifiers,
  listType,
  gallerySizeClasses = '',
  digitalDataOrigin,
  oneProductOnly = false,
}: Props) => {
  const { breakpoints } = useResponsive()
  const { data } = useGraphql<GetProductsByIdsQuery, GetProductsByIdsQueryVariables>(
    GET_PRODUCTS_BY_IDS,
    {
      variables: {
        productErpIdentifiers,
      },
    }
  )
  const products = data?.products?.filter(isNotNullOrUndefined) || []
  if (!products) {
    return null
  }

  return (
    <ConditionalWrapper
      condition={!oneProductOnly}
      wrapper={children => <div className="row sm-gutters u-w-100">{children}</div>}>
      <>
        {products.map((product, i) => (
          <ListItemRenderer
            ticket={''}
            product={product}
            key={i}
            listType={listType}
            imagePriority={i < 4}
            gallerySizeClasses={gallerySizeClasses}
            digitalDataOrigin={digitalDataOrigin}
            showSideButtons={breakpoints.max.SM}
          />
        ))}
      </>
    </ConditionalWrapper>
  )
}
